/* Game statuses — mirror the backend "status" wire values */
const LOADING = "loading"
const ERROR = "error"
const WAITING = "waiting"
const CHOICE = "choice"
const DEALING = "dealing"
const INSURANCE = "insurance"
const EVENMONEY = "evenmoney"
const GAME = "game"
const DEALER = "dealer"
const RESULT = "result"
const CLOSED = "closed"

export { LOADING, ERROR, WAITING, CHOICE, DEALING, INSURANCE, EVENMONEY, GAME, DEALER, RESULT, CLOSED }
